<template>
  <div style="font-size: 24px">
    <triz-validator rules="required" id="项目概述">
      <Tinymce @input="change" v-model="triz.backgroud.calculate" placeholder="项目中可改进的量化的指标，如速度/数量/成本等，必须要达到什么程度" />
    </triz-validator>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'

export default {
  components: {
    Tinymce,
  },
  props: {
    triz: {
      type: Object,
      default: () => ({}),
    },
  },
  model: {
    prop: 'triz',
    event: 'change',
  },
  data() {
    return {
      // triz: this.triz,
    }
  },
  mounted() {},
  methods: {
    change() {
      this.$emit('change', this.triz)
    },
  },
}
</script>
